import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaMicrosoft, FaGoogle } from 'react-icons/fa';
import { SiGmail, SiSlack, SiWhatsapp, SiDiscord, SiTelegram, SiNotion, SiHubspot, SiSalesforce, SiGithub, SiJira, SiAsana, SiZoom, SiDropbox, SiStripe } from 'react-icons/si';

const tools = [
  { icon: SiGmail, name: 'Gmail' }, { icon: FaMicrosoft, name: 'Outlook' },
  { icon: FaGoogle, name: 'Google Cal' }, { icon: SiSlack, name: 'Slack' },
  { icon: SiWhatsapp, name: 'WhatsApp' }, { icon: SiDiscord, name: 'Discord' },
  { icon: SiTelegram, name: 'Telegram' }, { icon: SiNotion, name: 'Notion' },
  { icon: SiHubspot, name: 'HubSpot' }, { icon: SiSalesforce, name: 'Salesforce' },
  { icon: SiGithub, name: 'GitHub' }, { icon: SiJira, name: 'Jira' },
  { icon: SiAsana, name: 'Asana' }, { icon: SiZoom, name: 'Zoom' },
  { icon: SiDropbox, name: 'Dropbox' }, { icon: SiStripe, name: 'Stripe' },
];

const Integrations = () => (
  <section className="py-24 bg-[#F7F5F2] border-t border-[#E4DFD8]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="tag-pill mx-auto mb-5 w-fit">Works where you work</div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A1A18] mb-4 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
          Connects to <span className="gradient-text-accent">15,000+ apps</span> out of the box.
        </h2>
        <p className="text-[#6B6560] text-base leading-relaxed">
          Your assistant doesn't wait for you to open an app. It lives natively in the tools your team already uses.
        </p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto"
      >
        {tools.map((tool) => (
          <div key={tool.name}
            className="group flex items-center gap-2 px-4 py-2.5 bg-white border border-[#E4DFD8] hover:border-[#B8CDD9] rounded-xl transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md cursor-default"
          >
            <tool.icon className="text-base text-[#9E9690] group-hover:text-[#1A1A18] transition-colors" />
            <span className="text-sm font-medium text-[#6B6560] group-hover:text-[#1A1A18] transition-colors">{tool.name}</span>
          </div>
        ))}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#EBF2F9] border border-[#C8DDE9] rounded-xl">
          <SafeIcon icon={FiIcons.FiPlus} className="text-[#2A5C8A]" />
          <span className="text-sm font-semibold text-[#2A5C8A] font-mono-custom">15,000 more</span>
        </div>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
        className="mt-10 text-center text-[10px] text-[#9E9690] font-mono-custom uppercase tracking-widest"
      >
        Powered by secure OAuth & API configurations
      </motion.p>
    </div>
  </section>
);

export default Integrations;